document.addEventListener('DOMContentLoaded', () => {
  // -----------------------------
  // Get the width of the scrollbar
  // -----------------------------
  // Create the measurement node
  const scrollDiv = document.createElement('div');
  const root = document.documentElement;

  scrollDiv.className = 'scrollbar-measure';
  document.body.appendChild(scrollDiv);

  // Get the scrollbar width
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  // Add it as a custom property
  root.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');

  // Delete the DIV
  document.body.removeChild(scrollDiv);

  // -----------------------------
  // Menu stuff
  // -----------------------------
  const menuToggle = document.querySelector('.js-menu-toggle');
  const overlayMenu = document.querySelector('.js-overlay-menu');
  const body = document.querySelector('body');
  const menuClosers = document.querySelectorAll('.js-menu-close');
  const menuBlur = document.querySelector('.js-menu-blur');

  function closeOverlayMenu() {
    body.classList.remove('overlay-menu-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    overlayMenu.classList.remove('is-open');
    menuBlur.classList.remove('visible');
  }

  function openOverlayMenu() {
    body.classList.add('overlay-menu-open');
    menuToggle.setAttribute('aria-expanded', 'true');
    overlayMenu.classList.add('is-open');
    menuBlur.classList.add('visible');
  }

  function toggleOverlayMenu() {
    if (overlayMenu.classList.contains('is-open')) {
      closeOverlayMenu();
    } else {
      openOverlayMenu();
    }
  }

  // Toggle button
  if (overlayMenu && menuToggle) {
    menuToggle.addEventListener('click', toggleOverlayMenu);
  }

  // Close buttons
  if (overlayMenu && menuClosers) {
    for (let i = 0; i < menuClosers.length; i++) {
      menuClosers[i].addEventListener('click', closeOverlayMenu);
    }
  }

  // Esc key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlayMenu.classList.contains('is-open')) {
      closeOverlayMenu();
    }
  });

  // Hover images
  // -------------

  // Find default image
  const defaultImage = document.querySelector('.menu__image-wrap--default');

  function showHoverImage() {
    // Get id
    const id = this.dataset.entryId;

    // find matching image
    const hoverImage = document.querySelector(
      '.js-menu-hover-image[data-id="' + id + '"]'
    );

    if (hoverImage) {
      hoverImage.classList.add('visible');

      if (defaultImage) {
        defaultImage.classList.remove('visible');
      }
    }
  }

  function hideHoverImage() {
    // Get id
    const id = this.dataset.entryId;

    // find matching image
    const hoverImage = document.querySelector(
      '.js-menu-hover-image[data-id="' + id + '"]'
    );

    if (hoverImage) {
      hoverImage.classList.remove('visible');

      if (defaultImage) {
        defaultImage.classList.add('visible');
      }
    }
  }

  // get hover items
  const hoverItems = document.querySelectorAll('.js-menu-hover-item');

  for (let i = 0; i < hoverItems.length; i++) {
    const hoverItem = hoverItems[i];

    hoverItem.addEventListener('mouseover', showHoverImage);
    hoverItem.addEventListener('mouseleave', hideHoverImage);
  }
});
